import { useCallback } from "react";
import { useCurrentProjectFocusesId } from "@radarly/core/project/use-cases";
import { Card } from "@radarly/models/cards";
import { editDatavizOptionsOnCard } from "@radarly/models/cards/editor";
import { setCardPrimaryMetric } from "@radarly/models/cards/editor";
import {
  getPrimaryMetricFromCard,
  hasMetricsAggsFromCard,
} from "@radarly/models/cards/metric";
import {
  getClauseFromCard,
  getWorkspaceIdCtxFromClause,
} from "@radarly/models/clause/getter";
import { DatavizHorizontalBarChart } from "@radarly/models/dataviz";

function addMetricOnCard(card: Card, projectFocuses: number[]) {
  if (hasMetricsAggsFromCard(card)) {
    return card;
  }
  const clause = getClauseFromCard(card);
  const workspaceId = getWorkspaceIdCtxFromClause(clause);
  const metric = getPrimaryMetricFromCard(card);
  return setCardPrimaryMetric(workspaceId, projectFocuses, card, metric);
}

export function useSetDataviz(card: Card, setCard?: (card: Card) => void) {
  const projectFocuses = useCurrentProjectFocusesId();
  const setDataviz = useCallback(
    (dataviz: DatavizHorizontalBarChart) => {
      setCard(
        editDatavizOptionsOnCard(addMetricOnCard(card, projectFocuses), dataviz)
      );
    },
    [setCard, card, projectFocuses]
  );
  return {
    setDataviz,
  };
}
